import {
  type SeverityLevel,
  captureException,
  captureMessage,
  startTransaction,
} from '@sentry/nextjs'

//Error meta-data (https://develop.sentry.dev/sdk/event-payloads/)
type ErrorContext = {
  tags?: {
    fn?: string
    component?: string
    [key: string]: string | number | undefined | boolean
  }
  extra?: Record<string, unknown>
}

export const sendToLogger = (
  err: unknown,
  errorContext?: ErrorContext,
  logLevel: SeverityLevel = 'error'
) => {
  // Log error to console in development mode for easier debugging
  if (process.env.NODE_ENV === 'development') {
    // eslint-disable-next-line no-console
    console.log(err)
  }

  captureException(err, {
    ...(errorContext && errorContext),
    level: logLevel,
  })
}

export const logger = {
  startTransaction: startTransaction,
  captureMessage: (message: string, captureContext: SeverityLevel) =>
    captureMessage(message, captureContext),
}
